import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';
import {
  ManageAccounts as ManageAccountsIcon,
  School as SchoolIcon,
} from '@mui/icons-material';
import PageHeader from '../../components/common/PageHeader';
import StaffOnboarding from './components/StaffOnboarding';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`management-tabpanel-${index}`}
      aria-labelledby={`management-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `management-tab-${index}`,
    'aria-controls': `management-tabpanel-${index}`,
  };
}

const Management: React.FC = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box>
      <PageHeader
        title="Management"
        subtitle="Manage staff onboarding and other administrative tasks"
      />

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="management tabs">
            <Tab 
              icon={<SchoolIcon />} 
              label="Staff Onboarding" 
              {...a11yProps(0)} 
              iconPosition="start"
            />
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
          <StaffOnboarding />
        </TabPanel>
      </Paper>
    </Box>
  );
};

export default Management;
